import { isMoment } from 'moment'
import { validateString } from '..'
import { getTimezoneLessMoment } from '../momentjs'
import { EUROPEAN_DATE } from '../constants'

export const TERMINATED = -1
export const INACTIVE = 0
export const ACTIVE = 1

export const Properties = Object.freeze({
  ID: 'id',
  BADGE_NUMBER: 'badgeNumber',
  RFID_NUMBER: 'rfidNumber',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  STUDENT_ID: 'studentId',
  STUDENT_FIRST_NAME: 'studentFirstName',
  STUDENT_LAST_NAME: 'studentLastName',
  BADGE_ASSIGNATION_ID: 'badgeAssignationId'
})

export const getters = Object.freeze({
  id: badge => badge.id,
  badgeNumber: badge => badge.badgeNumber,
  rfidNumber: badge => badge.rfidNumber,
  startDate: badge => badge.startDate,
  endDate: badge => badge.endDate,
  stringStartDate: badge => isMoment(badge.startDate) ? badge.startDate.format(EUROPEAN_DATE) : null,
  stringEndDate: badge => isMoment(badge.endDate) ? badge.endDate.format(EUROPEAN_DATE) : null,
  student: badge => badge.studentId ? `${badge.studentFirstName} ${badge.studentLastName}` : null,
  studentId: badge => badge.studentId,
  studentFirstName: badge => badge.studentFirstName,
  studentLastName: badge => badge.studentLastName,
  badgeAssignationId: badge => badge.badgeAssignationId,
  status: badge => badge.status
})

export const Validators = Object.freeze([
  { key: Properties.BADGE_NUMBER, validator: i => validateString(getters.badgeNumber(i), { notEmpty: true }) },
  { key: Properties.START_DATE, validator: i => getters.startDate(i) !== null },
  { key: Properties.STUDENT_ID, validator: i => getters.studentId(i) !== null }
])

export class BadgeAssignation {
  constructor ({
    id = -1, badgeNumber = null, rfidNumber = null, startDate = null, endDate = null, studentId = null, studentFirstName = null, studentLastName = null,
    badgeAssignationId = null, status = ACTIVE
  }) {
    this.id = id
    this.badgeNumber = badgeNumber
    this.rfidNumber = rfidNumber
    this.startDate = getTimezoneLessMoment(startDate)
    this.endDate = getTimezoneLessMoment(endDate)
    this.studentId = studentId
    this.studentFirstName = studentFirstName
    this.studentLastName = studentLastName
    this.badgeAssignationId = badgeAssignationId
    this.status = status
  }
}
